export const BLOG_NEWS = [
  // ── Gukesh ──────────────────────────────────────────────────────────────────
  {
    title: 'Gukesh Dommaraju: World Chess Champion Profile',
    url: 'https://www.shatranj.live/blogs/gukesh-dommaraju-world-chess-champion-profile',
    keywords: ['gukesh', 'gukesh dommaraju', 'dommaraju']
  },
  {
    title: "What Gukesh's Prague Slump Means for WCC 2026",
    url: 'https://www.shatranj.live/blogs/gukesh-prague-slump-wcc-2026',
    keywords: ['gukesh', 'gukesh dommaraju']
  },
  // ── Praggnanandhaa ─────────────────────────────────────────────────────────
  {
    title: 'Praggnanandhaa: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/praggnanandhaa-player-profile',
    keywords: ['praggnanandhaa', 'pragg', 'r praggnanandhaa']
  },
  // ── Arjun Erigaisi ─────────────────────────────────────────────────────────
  {
    title: 'Arjun Erigaisi: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/arjun-erigaisi-player-profile',
    keywords: ['arjun erigaisi', 'erigaisi', 'arjun']
  },
  // ── Nihal Sarin ────────────────────────────────────────────────────────────
  {
    title: 'Nihal Sarin: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/nihal-sarin-player-profile',
    keywords: ['nihal sarin', 'nihal', 'sarin']
  },
  // ── Nodirbek Abdusattorov ──────────────────────────────────────────────────
  {
    title: 'Nodirbek Abdusattorov: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/nodirbek-abdusattorov-player-profile',
    keywords: ['abdusattorov', 'nodirbek abdusattorov', 'nodirbek']
  },
  // ── Javokhir Sindarov ─────────────────────────────────────────────────────
  {
    title: 'Javokhir Sindarov: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/javokhir-sindarov-player-profile',
    keywords: ['sindarov', 'javokhir sindarov', 'javokhir']
  },
  // ── Aravindh Chithambaram ─────────────────────────────────────────────────
  {
    title: 'Aravindh Chithambaram: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/aravindh-chithambaram-player-profile',
    keywords: ['aravindh chithambaram', 'aravindh']
  },
  // ── Aarav Dengla ──────────────────────────────────────────────────────────
  {
    title: "Aarav Dengla: India's 93rd Grandmaster",
    url: 'https://www.shatranj.live/blogs/aarav-dengla-india-93rd-grandmaster',
    keywords: ['aarav dengla', 'dengla']
  },
  // ── Divya Deshmukh ────────────────────────────────────────────────────────
  {
    title: 'Divya Deshmukh: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/divya-deshmukh-player-profile',
    keywords: ['divya deshmukh', 'divya']
  },
  // ── Vaishali Rameshbabu ───────────────────────────────────────────────────
  {
    title: 'Vaishali Rameshbabu: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/vaishali-rameshbabu-player-profile',
    keywords: ['vaishali rameshbabu', 'vaishali', 'rameshbabu']
  },
  // ── Koneru Humpy ──────────────────────────────────────────────────────────
  {
    title: 'Koneru Humpy: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/koneru-humpy-player-profile',
    keywords: ['koneru humpy', 'koneru', 'humpy']
  },
  // ── Hou Yifan ─────────────────────────────────────────────────────────────
  {
    title: 'Hou Yifan: The Strongest Female Player in History',
    url: 'https://www.shatranj.live/blogs/hou-yifan-chess-profile',
    keywords: ['hou yifan', 'hou', 'yifan']
  },
  // ── Ju Wenjun ─────────────────────────────────────────────────────────────
  {
    title: "Ju Wenjun: Four-Time Women's World Champion",
    url: 'https://www.shatranj.live/blogs/ju-wenjun-chess-profile',
    keywords: ['ju wenjun', 'ju', 'wenjun']
  },
  // ── Judit Polgar ──────────────────────────────────────────────────────────
  {
    title: 'Judit Polgar: The Greatest Female Chess Player Ever',
    url: 'https://www.shatranj.live/blogs/judit-polgar-chess-profile',
    keywords: ['judit polgar', 'polgar', 'judit']
  },
  // ── Jorden van Foreest ────────────────────────────────────────────────────
  {
    title: 'Jorden van Foreest: Profile, Rating and Career',
    url: 'https://www.shatranj.live/blogs/jordan-van-foreest-player-profile',
    keywords: ['jordan van foreest', 'jorden van foreest', 'van foreest']
  },
  // ── Candidates Tournament ─────────────────────────────────────────────────
  {
    title: 'FIDE Candidates Tournament 2026 Preview',
    url: 'https://www.shatranj.live/blogs/candidates-tournament-2026-preview',
    keywords: ['gukesh', 'praggnanandhaa', 'caruana', 'nakamura', 'giri', 'candidates']
  },
  {
    title: 'What is the Candidates Tournament?',
    url: 'https://www.shatranj.live/blogs/what-is-the-candidates-tournament',
    keywords: ['candidates', 'gukesh', 'praggnanandhaa', 'caruana', 'nakamura']
  },
  {
    title: 'India Women at Candidates 2026: Vaishali, Divya & Koneru',
    url: 'https://www.shatranj.live/blogs/india-women-chess-candidates-2026',
    keywords: ['vaishali', 'divya deshmukh', 'koneru humpy', 'candidates']
  },
  // ── Tata Steel ────────────────────────────────────────────────────────────
  {
    title: 'India at Tata Steel 2026: All Four Players in the Top Section',
    url: 'https://www.shatranj.live/blogs/india-tata-steel-2026-all-four-players',
    keywords: ['praggnanandhaa', 'nihal sarin', 'gukesh', 'arjun erigaisi', 'tata steel']
  },
  // ── Prague ────────────────────────────────────────────────────────────────
  {
    title: 'Prague International Chess Festival 2026',
    url: 'https://www.shatranj.live/blogs/prague-international-chess-festival-2026',
    keywords: ['prague', 'aravindh', 'van foreest', 'abdusattorov', 'firouzja']
  },
  {
    title: 'Prague Chess Festival: History and Past Winners',
    url: 'https://www.shatranj.live/blogs/prague-chess-festival-history-past-winners',
    keywords: ['prague', 'aravindh', 'abdusattorov', 'firouzja', 'shankland', 'harikrishna']
  },
  {
    title: 'Prague Masters 2026 — Final Standings',
    url: 'https://www.shatranj.live/blogs/prague-masters-2026-final-standings',
    keywords: ['prague', 'van foreest', 'abdusattorov', 'firouzja', 'gukesh', 'aravindh']
  },
  {
    title: 'Prague Challengers 2026 — Final Standings',
    url: 'https://www.shatranj.live/blogs/prague-challengers-2026-final-standings',
    keywords: ['prague', 'sindarov', 'nihal sarin']
  },
  // ── Monthly / Ratings ─────────────────────────────────────────────────────
  {
    title: 'Chess February 2026: Month in Review',
    url: 'https://www.shatranj.live/blogs/chess-february-2026-month-in-review',
    keywords: ['gukesh', 'praggnanandhaa', 'arjun erigaisi', 'nihal sarin', 'aravindh']
  },
  {
    title: 'India FIDE March 2026 Ratings Update',
    url: 'https://www.shatranj.live/blogs/india-fide-march-2026-ratings',
    keywords: ['gukesh', 'arjun erigaisi', 'praggnanandhaa', 'nihal sarin', 'vidit', 'aravindh']
  },
  {
    title: 'Top Women Chess Players in 2026',
    url: 'https://www.shatranj.live/blogs/top-women-chess-players-2026',
    keywords: ['hou yifan', 'ju wenjun', 'koneru humpy', 'vaishali', 'divya', 'polgar']
  },
];

export default BLOG_NEWS;
